import { render, staticRenderFns } from "./StudentEditTabInformation.vue?vue&type=template&id=5a4e6962&"
import script from "./StudentEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports